import { styled } from "@mui/material/styles";

import {
  borderColor,
  inkColor,
  paperColor,
} from "~/styles/redesignColors";

const pillButton = {
  display: "inline-flex",
  flex: "none",
  alignItems: "center",
  gap: 5,
  height: 32,
  padding: "0 14px",
  borderRadius: 999,
  fontFamily: "inherit",
  fontSize: 12,
  fontWeight: 600,
  whiteSpace: "nowrap",
  cursor: "pointer",

  "& svg": {
    fontSize: 16,
  },

  "&:disabled": {
    cursor: "inherit",
  },
} as const;

export const InkButton = styled("button")(({ theme }) => ({
  ...pillButton,
  border: "none",
  backgroundColor: inkColor(theme),
  color: paperColor(theme),
}));

export const OutlinedButton = styled("button")(({ theme }) => ({
  ...pillButton,
  border: `1px solid ${borderColor(theme)}`,
  backgroundColor: paperColor(theme),
  color: inkColor(theme),
}));
